export const reducer = (state, action) => {
    if (!action) return state;

    const { type, payload } = action;
    switch (type) {
        case 'INIT': {
            // console.log('=== init payload ===', payload)
            return {
                ...state,
                ...payload
            };
        }

        case 'SELECT_CATEGORIES': {
            // console.log('=== selectCat ===', payload)
            const { categoryId, action } = payload;

            const categories = {
                sel: [...state.selectedCategoryIds],
                unsel: [...state.unselectedCategoryIds]
            };
            if (action === 'add') {
                const exists = categories.sel.findIndex((cat) => cat === categoryId) > -1;
                if (exists) return state;

                categories.sel.push(categoryId);

                return {
                    ...state,
                    unselectedCategoryIds: categories.unsel.filter((cat) => cat !== categoryId),
                    selectedCategoryIds: categories.sel
                };
            }

            if (action === 'remove') {
                const exists = categories.unsel.findIndex((cat) => cat === categoryId) > -1;
                if (exists) return state;

                categories.unsel.push(categoryId);

                return {
                    ...state,
                    selectedCategoryIds: categories.sel.filter((cat) => cat !== categoryId),
                    unselectedCategoryIds: categories.unsel
                };
            }
        }

        case 'ANSWER_SCREENING_QUESTION': {
            // don't destructure payload to allow for dynamic keys
            return {
                ...state,
                screeningAnswers: {
                    ...state.screeningAnswers,
                    ...payload
                }
            };
        }

        case 'TRAVERSE_STEPS': {
            const { direction } = payload;
            let stepId = state.currentStepId;
            const { steps, selectedCategoryIds, availableCategories } = state;
            let nextSteps = [...steps];

            if (direction === 'previous' && stepId === 0) {
                // navigate back to home.
                console.log('=== NO PREVIOUS STEP. NAVIGATING HOME ===');
                return state;
            }

            if (direction === 'next' && stepId === steps.length - 1) {
                // do some rerouting to checkout
                console.log('=== ALREADY ON LAST STEP. NAVIGATING TO CHECKOUT ===');
                return state;
            }

            if (direction === 'next' && state.currentStep.type === 'categorySelect') {
                // CONFIRM SELECTED CATEGORIES AND ADD THEM TO STEPS
                nextSteps = nextSteps.filter((s) => s.type !== 'shopCategory');

                selectedCategoryIds.forEach((catId) => {
                    const exists =
                        nextSteps.findIndex((s) => s.type === 'shopCategory' && s.category?.id === catId) > -1;
                    if (exists) return;

                    const categoryObject = availableCategories.find((c) => c.id === catId);
                    if (categoryObject)
                        nextSteps.push({
                            type: 'shopCategory',
                            category: categoryObject
                        });
                });
            }

            return {
                ...state,
                steps: nextSteps,
                currentStepId: direction === 'next' ? stepId + 1 : stepId - 1
            };
        }

        default:
            return state;
    }
};
